module.exports = __webpack_public_path__ + "static/media/value-poster-3.9a0f32fa.png";